module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (80).5412ecab.jpg";